const DEFAULT_REDIRECT = '/service/requests'

/** What `auth/login` answers. */
export interface LoginResponse {
    /** Not there yet while the second factor is still needed. */
    user?: { id: number } | null
    redirect?: string
}

/**
 * The page that sent the user to log in (`?redirect=`), but only a path on office itself: anything
 * else, such as `https://…` or `//…`, would send a freshly logged-in user off-site.
 */
export const getQueryRedirect = (): string | null => {
    const redirect = new URLSearchParams(window.location.search).get('redirect')

    if (redirect === null || !/^\/(?![/\\])/.test(redirect)) {
        return null
    }

    try {
        const target = new URL(redirect, window.location.origin)
        return target.origin === window.location.origin ? redirect : null
    } catch {
        return null
    }
}

/**
 * Where to go after logging in: the two-factor step the server asks for, the page that sent the
 * user to log in, or the requests overview.
 */
export const getRedirectAfterLogin = ({ user, redirect }: LoginResponse): string => {
    const queryRedirect = getQueryRedirect()

    if (!user && redirect) {
        return redirect + (queryRedirect ? `?redirect=${encodeURIComponent(queryRedirect)}` : '')
    }

    window._user = user
    const target = queryRedirect || redirect || DEFAULT_REDIRECT

    return target === '/' ? DEFAULT_REDIRECT : target
}
